import { sameEquipmentKey } from "@frontier/content/arsenal";
import type { EquipmentDefinition } from "@frontier/content/arsenal";
import { CONTRACTS } from "@frontier/content/contracts";
import { PUBLIC_EVENTS } from "@frontier/content/events";
import { regionRisk } from "@frontier/content/risk";

export function blueprintSources(item: EquipmentDefinition): string[] {
  const sources = item.blueprint
    ? [
        `${item.blueprint.successes} успешный вылет «${CONTRACTS[item.blueprint.contractId].title}»`,
      ]
    : [];
  for (const event of Object.values(PUBLIC_EVENTS)) {
    if (event.blueprintUnlocks.some((key) => sameEquipmentKey(key, item.key)))
      sources.push(
        `${regionRisk(event.sectorId) === "open-pvp" ? "Событие" : "PvE-событие"} «${event.title}» — успех и участие`,
      );
  }
  return sources;
}
